import LoadingComponent from "../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";

import Container from "react-bootstrap/Container";
import { Button } from 'semantic-ui-react'
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Image } from "semantic-ui-react";
import ListConveniosInstitucion from './handlers/ListConveniosInstitucion'
import SimpleFileUploadForm from "./handlers/ImagenInstitucional";

import Footer from "../Footer";

import "./src/pInstitucional.css";
import escudoGuate from "./src/img/escudo_guatemala_fondo.png";
import logoEje from "./src/img/logo-congreso-ejemplo.png";

interface Entidad {
  idEntidad: string;
  entidad: string;
}

let datain: any;
let datast: any;

export default observer(function ConveniosXinstitucion() {
  const [loading, setLoading] = useState(false);
  const { userStore: { user } } = useStore();

  const [modalShow, setModalShow] = useState(false);
  const [entidad, setEntidad] = useState();
  const [entidadId, setEntidadId] = useState();
  const [imgp, setImgp] = useState<any>(null);

  const getDetallePerfil = async () => {
    setLoading(true);

    const perfilAPI = process.env.REACT_APP_API_URL + `/AccountsManager/GetEntityByUser/${user?.id}`;
    const resp = await fetch(perfilAPI);
    datain = await resp.json();
    let enti = datain.entidad;
    let entiID = datain.idEntidad;

    const perfilImg = process.env.REACT_APP_API_URL + `/Storage/${entiID}/${"SGTEntidad"}`;
    const r = await fetch(perfilImg);
    datast = await r.json();
    const ultima = datast.length - 1;

    setImgp(datast[ultima]?.fileName);
    setEntidad(enti);
    setEntidadId(entiID);

    setLoading(false);
  }; useEffect(() => { getDetallePerfil() }, [entidad, entidadId, imgp]);

  return (
    <>
      <Container fluid className="header-institu">
        <Container fluid className="back-head"></Container>

        <Container className="content-head">
          <Row>
            <Col xs={5}>
              <Image src={escudoGuate} />
              <div className="logo-area">
                <Image src={`${process.env.REACT_APP_FILEPATH_PIN_IMG_URL}/${imgp}`} />
              </div>
            </Col>
            <Col xs={7}>
              <p>Perfil Institucional -</p>
              <h2>{entidad}</h2>
            </Col>
          </Row>

          <Row className="institu-area-botones">
            <Col className="institu-butt-area">
              {/* <Col className="institu-butt-area" xs={{ span: 3, offset: 7 }}> */}
              <Button onClick={() => setModalShow(true)} circular icon='image' />
            </Col>
          </Row>
          {/* <Row className="institu-area-botones">
            <Col className="institu-butt-area" xs={{ span: 3, offset: 7 }}>
            <Link to={'/perfil-institucional/'}>
              <Button disabled variant="btn btn-info">Regresar al Perfil</Button>
            </Link>

            </Col>
          </Row> */}
        </Container>
      </Container>

      <Container className="content-institu">

        <div className="title-area-institu">
          <h2>Lista de Códigos Institucionales:</h2>
        </div>

        <div className="bread-institu">
          {/* {myBreadCrumbsConvRaiz(activeC)} */}
        </div>

        <Row>
          <ListConveniosInstitucion />
        </Row>
      </Container>

      <Footer />

      <SimpleFileUploadForm
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        pinst={entidadId}
        ctype={"SGTEntidad"}

      />
    </>
  );


})